import {addToCart} from './add-to-cart';
const productPreview = () => {

    let eventsProductPreview = document.querySelectorAll("[data-js-event=openProductPreview]");
    if (eventsProductPreview) {
        eventsProductPreview.forEach(function (e) {
            e.addEventListener('click', function (evt) {
                evt.preventDefault();
                let id = e.dataset.id;
                let xhr = new XMLHttpRequest();
                xhr.open("GET", '/data/product-detail.json?id=' + id, true);
                xhr.onreadystatechange = function () {
                    if (this.readyState != 4) return;
                    let modalPreview = document.querySelector('[data-modal=product-preview]');
                    if (modalPreview) {
                        let dataJson = JSON.parse(this.responseText);
                        modalPreview.querySelector('.modal__title').innerHTML = dataJson.name + ' ' + dataJson.article;
                        modalPreview.querySelector('.article span').innerHTML = dataJson.article;
                        modalPreview.querySelector('.price').innerHTML = dataJson.price + ' ' + dataJson.currencyLang;
                        modalPreview.querySelector('.picture img').setAttribute('src', dataJson.image);
                        modalPreview.querySelector('.btn').dataset.id = dataJson.id;
                        let propsPreview = modalPreview.querySelector('.props');
                        if (propsPreview) {
                            propsPreview.innerHTML = '';
                            dataJson.props.forEach(function (dataProp) {
                                let propItem = document.createElement('div');
                                propItem.classList.add('prop-item');
                                propItem.innerHTML = dataProp.name + ': <span>' + dataProp.value + '</span>';
                                propsPreview.appendChild(propItem);
                            });
                        }
                        modals.open(false, "product-preview");
                    }
                }
                xhr.send();

            })
        })
    }

    let modalPreview = document.querySelector('[data-modal=product-preview]');
    if (modalPreview) {
        let btnToCart = modalPreview.querySelector('[data-js-event=addToCart]');
        if (btnToCart) {
            btnToCart.addEventListener('click', function () {
                let id = btnToCart.dataset.id;
                if (id && parseInt(id) > 0) {
                    addToCart(parseInt(id), 1);
                }
            })

        }
    }


}

export {productPreview}
